import { statiBilancio, statiIniziativa, statiPetizione, statiReferendum, statiSondaggio } from "../../Utilities/statiElementEnum";
// 👇 IMPORTATO Alert PER IL BANNER
import { Card, Button, Col, Row, Container, Alert } from "react-bootstrap";
import { useState, useEffect } from "react";
import { Link as ScrollLink, } from "react-scroll";

import PetizioniService from "../../../services/PetizioniService";
import ReferendaService from "../../../services/ReferendaService";
import BilancioPartecipativoService from "../../../services/BilancioPartecipativoService";
import SondaggioService from "../../../services/SondaggiService";
import SondaggioPartecipanteService from "../../../services/SondaggioPartecipanteService";

import CartaElementiHomepage from "./CartaElementiHomepage";

import { useNavigate } from "react-router-dom";
import { getStatusOrderPetizione, getStatusOrderReferendum, getStatusOrderBilancio, getStatusOrderIniziativa, getStatusOrderSondaggio } from "../../Utilities/getStatusOrder";
import { getStatusPetizione, getStatusReferendum, getStatusBilancio, getStatusIniziativa, getStatusSondaggio } from '../../Utilities/getStatus';
import { petizioni, referendum, bilancio_partecipativo, segnalazioni, iniziative, sondaggi, risposteSondaggiIcon } from '../../../utilities/icone'
import homepageImageDefault from '../../../immagini/homepage/homepage_image.png'
import { useLocation } from 'react-router-dom';
import iniziativaServiceInstance from "../../../services/IniziativaService";
import Sondaggio from '../../../immagini/icone_sidebar/sondaggio_dark.png'

const dayjs = require('dayjs'); // 👈 Assicurati che dayjs sia importato

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

export default function Homepage(props) {
    let query = useQuery();

    //fetch dei dati
    let [listaPetizioni, setListaPetizioni] = useState([])
    const [loadingPet, setLoadingPet] = useState(true)
    let [listaReferendum, setListaReferenum] = useState([])
    const [loadingRef, setLoadingRef] = useState(true)
    let [listaBilanci, setListaBilanci] = useState([])
    const [loadingBil, setLoadingBil] = useState(true)
    let [listaIniziative, setListaIniziative] = useState([])
    const [loadingIni, setLoadingIni] = useState(true)
    let [listaSondaggi, setListaSondaggi] = useState([])
    const [loadingSon, setLoadingSon] = useState(true)

    const [rispostePerSondaggio, setRispostePerSondaggio] = useState({});

    const moduliAttivi = [
        props.comune.impostazioniComune.imcModuloPetizioniAttivo,
        props.comune.impostazioniComune.imcModuloReferendumAttivo,
        props.comune.impostazioniComune.imcModuloBilanciAttivo,
        props.comune.impostazioniComune.imcModuloSegnalazioniAttivo,
        props.comune.impostazioniComune.imcModuloSondaggiAttivo,
        props.comune.impostazioniComune.imcModuloIniziativeAttivo,
    ].filter(Boolean);

    const navigate = useNavigate();

    const getBannerUrl = () => {
        if (props.comune.comBannerFile)
            return "data:image/png;base64," + props.comune.comBannerFile
        else
            return homepageImageDefault
    }

    useEffect(() => {
        const cfbase64 = query.get('code')
        const token = query.get('token')
        if (cfbase64 && token) {
            sessionStorage.setItem('partecipante', JSON.stringify(cfbase64))
            sessionStorage.setItem('token', btoa(JSON.stringify(token)))
            props.setCaricaPartecipante(true)
        }
    }, [props.setCaricaPartecipante])

    useEffect(() => {
        if (props.comune.comId) {
            PetizioniService.findByComune(props.comune.comId)
                .then(res => { setListaPetizioni(res.data) })
                .catch((err) => { setListaPetizioni([]) })
                .finally(() => { setLoadingPet(false) })
            ReferendaService.findByComune(props.comune.comId)
                .then(res => { setListaReferenum(res.data) })
                .catch(() => { setListaReferenum([]) })
                .finally(() => { setLoadingRef(false) })
            BilancioPartecipativoService.getAllByComune(props.comune.comId)
                .then(res => { setListaBilanci(res.data) })
                .catch((err) => { setListaBilanci([]) })
                .finally(() => { setLoadingBil(false) })
            
            iniziativaServiceInstance.getIniziativaWithoutProjects(props.comune.comId)
                .then(res => {
                    setListaIniziative(res.data)
                })
                .catch((err) => { setListaIniziative([]) })
                .finally(() => { setLoadingIni(false) })

            const fetchSondaggi = async () => {
                try {
                    const res = await SondaggioService.getAllByComune(props.comune.comId);
                    const sondaggi = res.data;
                    setListaSondaggi(sondaggi);
                    const risposte = {};
                    await Promise.all(
                        sondaggi.map(async sondaggio => {
                            try {
                                const res = await SondaggioPartecipanteService.getTotalePartecipantiSondaggio(sondaggio.sonId);
                                risposte[sondaggio.sonId] = res.data;
                            } catch (err) {
                                console.error(`Errore nel recupero delle risposte per il sondaggio ${sondaggio.sonId}`, err);
                                risposte[sondaggio.sonId] = 0;
                            }
                        })
                    );
                    setRispostePerSondaggio(risposte);
                } catch (err) {
                    console.error("Errore nel caricamento dei sondaggi:", err);
                    setListaSondaggi([]);
                } finally {
                    setLoadingSon(false);
                };
            }
            fetchSondaggi();
        }
    }, [props.comune, navigate]);

    // 👇 LOGICA MANUTENZIONE 👇
    const today = dayjs().startOf('day');
    const maintenanceDate = props.comune.comDataManutenzione ? dayjs(props.comune.comDataManutenzione).startOf('day') : null;
    
    let isMaintenanceToday = false;
    let isMaintenanceFuture = false;

    if (maintenanceDate && maintenanceDate.isValid()) {
        if (maintenanceDate.isSame(today)) {
            isMaintenanceToday = true;
        } else if (maintenanceDate.isAfter(today)) {
            isMaintenanceFuture = true;
        }
    }

    // SE SIAMO NELLA DATA DI MANUTENZIONE, MOSTRA SOLO LA PAGINA "LAVORI IN CORSO"
    if (isMaintenanceToday) {
        return (
            <Container className="d-flex flex-column justify-content-center align-items-center" style={{ minHeight: "70vh" }}>
                <Card className="text-center p-5 shadow-lg" style={{ maxWidth: "600px", borderTop: "5px solid #ffc107" }}>
                    <Card.Body>
                        <h1 className="display-4 text-warning mb-3">Lavori in Corso</h1>
                        <h4 className="mb-4">Il sistema è attualmente in manutenzione.</h4>
                        <p className="lead text-muted">
                            {props.comune.comDescManutenzione || "Stiamo effettuando un aggiornamento del sistema. Torneremo online a breve."}
                        </p>
                    </Card.Body>
                </Card>
            </Container>
        );
    }

    // ALTRIMENTI MOSTRA LA HOMEPAGE STANDARD (con o senza banner futuro)
    return (
        <>
            {/* 👇 BANNER MANUTENZIONE FUTURA 👇 */}
            {isMaintenanceFuture && (
                <Container className="px-md-5 mt-4">
                    <Alert variant="warning" className="text-center shadow-sm">
                        <Alert.Heading className="mb-1">Avviso di Manutenzione Programmata</Alert.Heading>
                        <p className="mb-0">
                            <strong>{maintenanceDate.format('DD/MM/YYYY')}:</strong> {props.comune.comDescManutenzione || "È previsto un intervento di manutenzione sul sistema."}
                        </p>
                    </Alert>
                </Container>
            )}

            <Card className={`${isMaintenanceFuture ? 'mt-2' : 'mt-md-5'} mx-md-5`}>
                <Row className="w-100 p-0 m-0">
                    <Col sm={6} className="d-flex align-items-center">
                        <Card.Body className="text-center p-2">
                            <div className="my-auto">
                                <Card.Title className=" mb-4">
                                    <h1 className="title">{props.comune.comNome} Partecipa!</h1>
                                </Card.Title>
                                <Card.Text>
                                    {props.comune.comSottotitolo ? (
                                        <strong>{props.comune.comSottotitolo}</strong>
                                    ) : (
                                        <strong>Scopri i processi di democrazia partecipativa attivi, dai un contributo alla tua città!</strong>
                                    )}
                                    <br />
                                    <br />
                                    {props.comune.comDescrizione ? (
                                        <span className="italic">{props.comune.comDescrizione}</span>
                                    ) : (
                                        <span className="italic">
                                            Questa è la piattaforma del comune per la partecipazione dei cittadini alla vita della città. Rende possibile pubblicare e votare petizioni, referendum e proposte.
                                        </span>
                                    )}
                                </Card.Text>
                            </div>
                        </Card.Body>
                    </Col>
                    <Col sm={6} className="d-none d-sm-flex align-items-center p-0">
                        <Card.Img src={getBannerUrl()} style={{ maxHeight: "50vh" }} />
                    </Col>
                </Row>
            </Card>

            {
                props.comune && props.comune.impostazioniComune &&
                moduliAttivi.length > 1 &&
                <Container className="text-center mt-4 mx-4 mx-md-5" fluid="true" >
                    <Card border="secondary" className="mt-2">
                        <Card.Body className="p-0">
                            <Row className="gx-2 gy-3 justify-content-start">
                                {props.comune.impostazioniComune.imcModuloPetizioniAttivo &&
                                    <Col xs={6} md={3} >
                                        <ScrollLink to="petizioni" offset={-70} spy={true} duration={70000} className="w-100">
                                            <Button variant="outline-light p-3 w-100 h-100" style={{ color: "black" }} >
                                                {petizioni}{' '} Petizioni
                                            </Button>
                                        </ScrollLink>
                                    </Col>
                                }
                                {props.comune.impostazioniComune.imcModuloReferendumAttivo &&
                                    <Col xs={6} md={3} >
                                        <ScrollLink to="referendum" offset={-70} spy={true} duration={70000} className="w-100">
                                            <Button variant="outline-light p-3 w-100 h-100" style={{ color: "black" }} >
                                                {referendum}{' '} Referendum
                                            </Button>
                                        </ScrollLink>
                                    </Col>
                                }
                                {props.comune.impostazioniComune.imcModuloSegnalazioniAttivo &&
                                    <Col xs={6} md={3} >
                                        <ScrollLink to="segnalazioni" offset={-70} spy={true} duration={70000} className="w-100">
                                            <Button variant="outline-light p-3 w-100 h-100" style={{ color: "black" }}>
                                                {segnalazioni} {' '} Segnalazioni
                                            </Button>
                                        </ScrollLink>
                                    </Col >
                                }
                                {props.comune.impostazioniComune.imcModuloBilanciAttivo &&
                                    <Col xs={6} md={3} >
                                        <ScrollLink to="bilancio" offset={-70} spy={true} duration={70000} className="w-100">
                                            <Button variant="outline-light p-3 w-100 h-100" style={{ color: "black" }}>
                                                {bilancio_partecipativo} {' '} {props.comune.impostazioniComune.imcLabelModuloBilanci}
                                            </Button>
                                        </ScrollLink>
                                    </Col>
                                }
                                {props.comune.impostazioniComune.imcModuloIniziativeAttivo &&
                                    <Col xs={6} md={3} >
                                        <ScrollLink to="iniziativa" offset={-70} spy={true} duration={70000} className="w-100">
                                            <Button variant="outline-light p-3 w-100 h-100" style={{ color: "black" }}>
                                                {iniziative} {' '} {props.comune.impostazioniComune.imcLabelModuloIniziative}
                                            </Button>
                                        </ScrollLink>
                                    </Col>
                                }
                                {props.comune.impostazioniComune.imcModuloSondaggiAttivo &&
                                    <Col xs={6} md={3} >
                                        <ScrollLink to="sondaggio" offset={-70} spy={true} duration={70000} className="w-100">
                                            <Button variant="outline-light p-3 w-100 h-100" style={{ color: "black" }} >
                                                <img
                                                    src={Sondaggio}
                                                    alt="Sondaggi"
                                                    style={{ width: "35px", height: "35px", marginRight: "8px" }}
                                                />{' '} {props.comune.impostazioniComune.imcLabelModuloSondaggi}
                                            </Button>
                                        </ScrollLink>
                                    </Col>
                                }
                            </Row>
                        </Card.Body>
                    </Card>
                </Container>
            }

            {/* LISTE DEGLI ELEMENTI */}
            <Card className="mt-4  mb-5 mx-4 mx-md-5">
                {props.comune && props.comune.impostazioniComune && props.comune.impostazioniComune.imcModuloPetizioniAttivo &&
                    <CartaElementiHomepage
                        titolo="Petizioni"
                        identificativo="petizioni"
                        testoLink="Vedi di più"
                        path="/esplora-petizioni"
                        partecipante={props.partecipante}
                        listaElementi={listaPetizioni && listaPetizioni.length > 0 && listaPetizioni
                            .map(el => { return { ...el, petStato: getStatusPetizione(el, props.comune) } })
                            .filter(el => (
                                el.petStato !== statiPetizione.InValidazione &&
                                el.petStato !== statiPetizione.Rifiutata
                            ))
                            .sort(function (a, b) {
                                return getStatusOrderPetizione(a.petStato) - getStatusOrderPetizione(b.petStato)
                            })
                        }
                        comune={props.comune}
                        mode="petizione"
                        loading={loadingPet}
                    />
                }

                {props.comune && props.comune.impostazioniComune && props.comune.impostazioniComune.imcModuloReferendumAttivo &&
                    <CartaElementiHomepage
                        titolo="Referendum"
                        identificativo="referendum"
                        path="/esplora-referendum"
                        testoLink="Vedi di più"
                        loading={loadingRef}
                        mode="referendum"
                        partecipante={props.partecipante}
                        listaElementi={listaReferendum && listaReferendum.length > 0 &&
                            listaReferendum
                                .map(ref => { return { ...ref, refStato: getStatusReferendum(ref, props.comune) } })
                                .filter(el => (
                                    el.refStato !== statiReferendum.InValidazione &&
                                    el.refStato !== statiReferendum.Rifiutato
                                ))
                                .sort(function (a, b) {
                                    return getStatusOrderReferendum(a.refStato) - getStatusOrderReferendum(b.refStato)
                                })
                        }
                        comune={props.comune}
                    />
                }

                {props.comune && props.comune.impostazioniComune && props.comune.impostazioniComune.imcModuloSegnalazioniAttivo &&
                    <CartaElementiHomepage
                        titolo="Segnalazioni"
                        identificativo="segnalazioni"
                        path="/esplora-segnalazioni"
                        testoLink="Vedi di più"
                        loading={false}
                        mode="segnalazione"
                        partecipante={props.partecipante}
                        listaElementi={[]}
                        comune={props.comune}
                    />
                }

                {props.comune && props.comune.impostazioniComune && props.comune.impostazioniComune.imcModuloBilanciAttivo &&
                    <CartaElementiHomepage
                        titolo={props.comune.impostazioniComune.imcLabelModuloBilanci}
                        identificativo="bilancio"
                        path="/esplora-bilanci-partecipativi"
                        testoLink="Vedi di più"
                        loading={loadingBil}
                        mode="bilancio"
                        partecipante={props.partecipante}
                        listaElementi={listaBilanci
                            .map(bil => { return { ...bil, bilStato: getStatusBilancio(bil, props.comune) } })
                            .filter(el => el.bilStato !== statiBilancio.NonPubblicato)
                            .sort(function (a, b) {
                                return getStatusOrderBilancio(b.bilEdizione) - getStatusOrderBilancio(a.bilEdizione)
                            })}
                        comune={props.comune}
                    />
                }

                {props.comune && props.comune.impostazioniComune && props.comune.impostazioniComune.imcModuloIniziativeAttivo &&
                    <CartaElementiHomepage
                        titolo={props.comune.impostazioniComune.imcLabelModuloIniziative}
                        identificativo="iniziativa"
                        path="/esplora-iniziative"
                        testoLink="Vedi di più"
                        loading={loadingIni}
                        mode="iniziativa"
                        partecipante={props.partecipante}
                        listaElementi={listaIniziative
                            .map(ini => { return { ...ini, iniStato: getStatusIniziativa(ini, props.comune) } })
                            .filter(el => el.iniStato !== statiIniziativa.NonPubblicata)
                            .sort(function (a, b) {
                                return getStatusOrderIniziativa(b.iniEdizione) - getStatusOrderIniziativa(a.iniEdizione)
                            })}
                        comune={props.comune}
                    />
                }
                {props.comune && props.comune.impostazioniComune && props.comune.impostazioniComune.imcModuloSondaggiAttivo &&
                    <CartaElementiHomepage
                        titolo={props.comune.impostazioniComune.imcLabelModuloSondaggi}
                        identificativo="sondaggio"
                        path="/esplora-sondaggi"
                        testoLink="Vedi di più"
                        loading={loadingSon}
                        mode="sondaggio"
                        partecipante={props.partecipante}
                        listaElementi={listaSondaggi
                            .map(son => { return { ...son, sonStato: getStatusSondaggio(son, props.comune), numeroRisposte: rispostePerSondaggio[son.sonId] || 0 } })
                            .filter(el => el.sonStato !== statiSondaggio.NonPubblicato)
                        }
                        comune={props.comune}
                    />
                }

            </Card>
        </>
    )
}